export enum RefundType {
  AMOUNT = "AMOUNT",
  ITEMS = "ITEMS",
}

export enum RefundItemPricingMode {
  QUANTITY = "QUANTITY",
  PACKAGE_REMAINING_VALUE = "PACKAGE_REMAINING_VALUE",
  FIXED_AMOUNT = "FIXED_AMOUNT",
}

export enum RefundItemAction {
  RESTORE_INVENTORY = "RESTORE_INVENTORY",
  RESTORE_MEMBER_DISCOUNT = "RESTORE_MEMBER_DISCOUNT",
  RESTORE_SAVED_ITEM = "RESTORE_SAVED_ITEM",
  CANCEL_PACKAGE = "CANCEL_PACKAGE",
  RESTORE_PACKAGE_SESSION = "RESTORE_PACKAGE_SESSION",
  REVERSE_MEMBERSHIP = "REVERSE_MEMBERSHIP",
  DISABLE_GIFT_CARD = "DISABLE_GIFT_CARD",
  REVOKE_LOYALTY = "REVOKE_LOYALTY",
  REVOKE_BANKED_VALUE = "REVOKE_BANKED_VALUE",
}

export enum RefundReason {
  DUPLICATE = "DUPLICATE",
  DISPUTE = "DISPUTE",
  BOOKING_FEE = "BOOKING_FEE",
  SERVICE_ISSUE = "SERVICE_ISSUE",
  PRODUCT_RETURN = "PRODUCT_RETURN",
  APPLIED_TO_OTHER_PURCHASE = "APPLIED_TO_OTHER_PURCHASE",
  PROVIDER_CANCELLATION = "PROVIDER_CANCELLATION",
  PATIENT_CANCELLATION = "PATIENT_CANCELLATION",
  MEDICAL_REASON = "MEDICAL_REASON",
  GOODWILL = "GOODWILL",
  OTHER = "OTHER",
}

export enum RefundDestination {
  ORIGINAL_METHOD = "ORIGINAL_METHOD",
  PATIENT_CREDIT = "PATIENT_CREDIT",
}
